import { defineComponent, openBlock, createBlock, Transition, withCtx, withDirectives, createElementVNode, renderSlot, createTextVNode, toDisplayString, vShow } from 'vue';
import { s as styleInject } from '../../../style-inject.es-87955792.js';

var script = defineComponent({
  name: 'OrTooltipContent',
  props: {
    isShown: {
      type: Boolean,
      required: false,
      default: true
    },
    content: {
      type: String,
      required: false,
      default: ''
    }
  }
});

const _hoisted_1 = {
  class: "or-tooltip"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, {
    name: "fade",
    persisted: ""
  }, {
    default: withCtx(() => [withDirectives(createElementVNode("div", _hoisted_1, [renderSlot(_ctx.$slots, "default", {}, () => [createTextVNode(toDisplayString(_ctx.content), 1 /* TEXT */)])], 512 /* NEED_PATCH */), [[vShow, _ctx.isShown]])]),
    _: 3 /* FORWARDED */
  });
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-4429227d {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-4429227d {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-tooltip[data-v-4429227d] {\n  z-index: 1;\n  width: fit-content;\n  height: fit-content;\n  padding: var(--s-2) var(--s-3);\n  margin: auto;\n  font-size: var(--fs-0);\n  font-weight: 500;\n  line-height: var(--lh-0);\n  color: var(--c-neutral-0);\n  background-color: var(--c-neutral-6);\n  border-radius: var(--s-1);\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-4429227d";
script.__file = "src/components/or-tooltip/or-tooltip-content/OrTooltipContent.vue";

export { script as OrTooltipContent };
